export const LoginStatuses = {
    running: 'running',
    pending: 'pending',
    failed: 'failed',
    completed: 'completed',
    bot_protection: 'bot_protection'
};